// extracted by mini-css-extract-plugin
export default {"tabBody":"style--tabBody--8479d5","hidden":"style--hidden--799804"};